const Gateway = () =>
  import(
    /* webpackChunkName: "company-companies" */ '@/pages/courier/gateway/index.vue'
  )

export default {
  path: 'gateway',
  meta: { label: 'gateway' },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'CourierGateway',
      path: ':id',
      meta: { label: 'Edit' },
      component: Gateway,
      props: true
    }
  ]
}
